export class FortemSDKError extends Error {
    code;
    status;
    detail;
    constructor(message, code, status, detail) {
        super(message);
        this.code = code;
        this.status = status;
        this.detail = detail;
        this.name = 'FortemSDKError';
    }
}
export class FortemSDKValidationError extends FortemSDKError {
    constructor(detail) {
        super('Invalid request input.', 'VALIDATION_ERROR', 0, detail);
        this.name = 'FortemSDKValidationError';
    }
}
export const isFortemSDKError = (error) => {
    if (error instanceof FortemSDKError) {
        return true;
    }
    if (!error || typeof error !== 'object') {
        return false;
    }
    return ('message' in error &&
        typeof error.message === 'string' &&
        'code' in error &&
        typeof error.code === 'string' &&
        'status' in error &&
        typeof error.status === 'number');
};
export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again or contact Tech.') => {
    if (isFortemSDKError(error)) {
        return error.message;
    }
    if (error instanceof Error && error.message) {
        return error.message;
    }
    return fallback;
};
export const getErrorDescription = (error) => {
    if (!isFortemSDKError(error)) {
        return undefined;
    }
    return [error.code, error.status > 0 ? `HTTP ${error.status}` : undefined]
        .filter(Boolean)
        .join(' · ');
};
